import * as React from 'react';
import * as Commonmark from 'react-commonmark';
import { IContent } from '../../../../services/content/models';
import { Row } from 'react-bootstrap';
import { destroy } from 'redux-form';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { IQuoteActions } from '../../../../services/quote/models';
import { connect } from 'react-redux';
import { flow } from 'lodash';
import { bindActionCreators } from 'redux';
import Helmet from 'react-helmet';

interface IBasicPageProps {
  page: IContent;
  actions: {
    quote: IQuoteActions;
    destroy(formName: string);
  };
}

class Cookies extends React.Component<IBasicPageProps> {
  public render() {
    const { page: { sections } } = this.props;
    return (
      <div className="container cookie-page">
        <Helmet>
          <title>Cookie Policy</title>
        </Helmet>
        <Row className="internal-page-container">
          <div className="internal-page-content">
            <h4>{sections.header}</h4>
            <Commonmark source={sections.body}/>
          </div>
        </Row>
      </div>
    );
  }
}

export default flow([
  connect(null,
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
      },
    }),
  ),
])(Cookies);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Content/scenes/Cookies/index.tsx